export interface GetCookieValueData {
  name: string;
}

export function GetCookieValueHandler(data: GetCookieValueData, webchat: any) {
    if (data?.name == null) {
        console.warn('Trying to retrieve cookie without name being specified');
        webchat.sendMessage('', { success: false });
        return;
    }

    const cookieValue = getCookieByName(data.name);
    if (cookieValue == null) {
        console.warn(`Trying to retrieve cookie with name "${data.name}", but none was found`);
        webchat.sendMessage('', { success: false });
        return;
    }
    webchat.sendMessage('', { success: true, cookieValue });
}

// As per https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#example_2_get_a_sample_cookie_named_test2
function getCookieByName(name: string) {
    return decodeURIComponent(document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${name}=`))
        ?.split('=')[1]);
}
